// // スタイルシート（Sass）を読み込む
import '../css/style.scss';

// tailwind elements
import 'tw-elements';

// // flowbite elements
// import 'flowbite';

// flatpickr
import flatpickr from "flatpickr"
import {Japanese} from "flatpickr/dist/l10n/ja.js"

require("flatpickr/dist/themes/material_orange.css");

// moment.js
import moment from 'moment';

/* ---------------------------------------------------------------------------
 * スクロールTOPに戻るボタン制御
 * --------------------------------------------------------------------------- */
let topButton = document.getElementById('btn-back-to-top');

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};

function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        topButton.style.display = 'block';
    } else {
        topButton.style.display = 'none';
    }
}

// When the user clicks on the button, scroll to the top of the document
topButton.addEventListener('click', backToTop);

function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

/**
 * language selector
 */
let langSel = document.getElementById('langSel');
if (langSel !== undefined && langSel != null) {
    langSel.addEventListener('change', function () {

        // 現在のURIから言語URLを取得
        let urlPath = '//' + location.host
            + this.value + location.pathname + location.search + location.hash;

        // 多言語サイトに移動
        location.href = urlPath;
    });
}

/* ---------------------------------------------------------------------------
 * flatpickerがある場合は表示
 * IDはtabione-flatpickerとします。
 *
 * 参考サイト
 * https://tr.you84815.space/flatpickr/
 *
 * 例）
 *   <input class="flatpickr" type="text" id="tabione-flatpicker" readonly="readonly">
 * --------------------------------------------------------------------------- */

(function ($) {

    moment.locale("ja");

    let fpElem = document.getElementById('tabione-flatpicker');

    if (fpElem) {
        // 日曜日始まり
        flatpickr.l10ns.ja.firstDayOfWeek = 0;

        let config = {
            altInput: true,
            altFormat: "Y年m月d日",
            locale: Japanese,
            defaultDate: new Date().fp_incr(5),
            dateFormat: "Y-m-d",
            minDate: "today",
            maxDate: new Date().fp_incr(365),
            disableMobile: "true",
        }

        let fp = flatpickr(fpElem, config);

        document.getElementById('fpOpenButton')
            .addEventListener('click', function () {
                fp.open();
            }, false);


        fpElem.onchange = function () {
            setTCalFormDate(this.value);
        };
        fpElem.onchange(); // 初回強制発火
    }

    // next days
    for (let i = 1; i <= 4; i++) {
        $('#tCalNextDate')
            .append('<div class="tCalNextDay w-1/2" data-nextday="'
                + moment().add(i, 'days').format('YYYY-MM-DD') + '">'
                + moment().add(i, 'days').format('M/D(ddd)') + '</div>');

    }

    // Next day Click
    $('.tCalNextDay').click(function () {
        setTCalFormDate(this.getAttribute('data-nextday'));
        document.tCalForm.submit();
    });

    /**
     * tCalFormのDateをセットします
     * @param date YYYY-MM-DD
     */
    function setTCalFormDate(date) {
        document.getElementById('tfpYear1').value
            = moment(date, 'YYYY-MM-DD').format('YYYY');
        document.getElementById('tfpMonth1').value
            = moment(date, 'YYYY-MM-DD').format('MM');
        document.getElementById('tfpDay1').value
            = moment(date, 'YYYY-MM-DD').format('DD');
    }

}(jQuery));

